import React from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { manualBetStore } from '../../../../store';
import { BetSection } from './betSection';
import { AddNewSectionBtn } from '../../../../components/common/bettingPart';

export const ManualBetSection = observer(({ t, handleOpenNumPad }) => {
  const { limits } = gameConfigStore;

  return (
    <div className='crash-bet-section'>
      {/* For crash-bet-section add class or attribute // disabled // to disable it */}
      <div className='crash-bet-section-inside'>
        {manualBetStore.betsSectionsData.map((item, i) => (
          <BetSection
            isAutoCashOut={item.isAutoCashOut}
            autoCashOutOdd={item.autoCashOutOdd}
            betAmount={item.betAmount}
            isOpen={item.isOpen}
            index={item.index}
            key={item.index}
            handleOpenNumPad={handleOpenNumPad}
            isLoaderActive={item.isLoaderActive}
            limits={limits}
            i={i}
            t={t}
          />
        ))}
        {!manualBetStore.isDoubleSectionsOpen && <AddNewSectionBtn t={t} />}
      </div>
    </div>
  );
});
